import axios from 'axios';
import * as Config from '../../config';

const state = {
    monos: {},
};

const actions = {
    load_Monos({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/list/all/' + form.study)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Mono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/consult/' + form.id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    mono_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/store', form)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    commit('LOGIN_FAIL');
                    reject(error.response.data);
                });
        });
    },
    changeActive_Mono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    Config.apiPath +
                    'mono/change/active/' +
                    form.id +
                    '/' +
                    form.active,
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeStatus_Mono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    Config.apiPath +
                    'mono/change/status/' +
                    form.id +
                    '/' +
                    form.status,
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_Mono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/update/' + form.id, form)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_pass_afip({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/update/afip/pass/' + form.id, form)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_Mono_on_AFIP({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/consult/' + form.id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    delete_Mono({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    Config.apiPath +
                    'mono/change/active/' +
                    form.id +
                    '/' +
                    form.active,
                )
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    mono_delete({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/delete', form)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    mono_generateInformeMensual({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mono/generate-informe-mensual/' + form.userId, form)
                .then(response => {
                    resolve(response.data); 
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    mono_getInformeMensual({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mono/get-informe-mensual/' + form.cuit + '/' + form.link)
                .then(response => {
                    resolve(response.data); 
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },     
    /*
    mono_informe_pdf({ commit, dispatch }, form) {

        let route = form.type == 'mensual'
            ? Config.apiPath + "mono/send-pdf/userId/" + form.userId + "/period/" + form.period + "/type/" + form.type
            : Config.apiPath + 'mono/get-pdf/userId/' + form.userId + '/type/' + form.type;
        console.log(route);
        return new Promise((resolve, reject) => {
            axios
                .get(route, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    */
    mono_vep_generate({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/vep/generate', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_vep_list_all({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/vep/list-all/' + form.id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    /*
    mono_vep_get_pdf({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/vep/get-pdf/idUser/' + form.id + '/nroVep/' + form.nroVep, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    */
    mono_codigo_revista_pdf({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/codigo-revista-pdf/' + form.id, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_vep_get_pdf({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/vep/get-pdf/idUser/' + form.clientId + '/nroVep/' + form.fileName, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_delegate_afip({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/delegate-afip', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_getRetenciones({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/get-retenciones?id='+form.id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_getStatus({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/get-status', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_getById({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'mono/get-by-id/'+form.id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mono_dateGetBalance({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'mono/date-get-balance', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
};
